import { render, staticRenderFns } from "./LxReport.vue?vue&type=template&id=54516f7d&scoped=true"
import script from "./LxReport.vue?vue&type=script&lang=js"
export * from "./LxReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54516f7d",
  null
  
)

export default component.exports